import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class LowStockIndicator extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch;

  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest(`.shopify-section, dialog`);
    const onVariantUpdated = /** @param {VariantUpdateEvent} event */ (event) => {
      const variantId = event.detail?.resource?.id;
      if (!variantId) return;
      if (String(variantId) !== this.dataset.variantId) {
        this.dataset.variantId = String(variantId);
      }
      this.#fetchAndMorph();
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, onVariantUpdated);
    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, onVariantUpdated);
      if (this.#activeFetch) this.#activeFetch.abort();
    };
  }

  #createAbortController() {
    if (this.#activeFetch) this.#activeFetch.abort();
    this.#activeFetch = new AbortController();
    return this.#activeFetch;
  }

  #fetchAndMorph() {
    const variantId = this.dataset.variantId;
    const sectionId = this.dataset.sectionId;
    const url = this.dataset.productUrl;
    if (!variantId || !sectionId || !url) return;

    const ac = this.#createAbortController();
    fetch(`${url}?variant=${variantId}&section_id=${sectionId}`, { signal: ac.signal })
      .then((r) => r.text())
      .then((htmlText) => {
        if (ac.signal.aborted) return;
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const next = html.querySelector(`low-stock-indicator[data-variant-id="${variantId}"]`);
        if (next) {
          morph(this, next);
        }
      })
      .catch((_e) => {
        // Silence; keep current UI
      });
  }
}

if (!customElements.get('low-stock-indicator')) {
  customElements.define('low-stock-indicator', LowStockIndicator);
}


